import './CompletionExamMain.scss';
import {useCommonStore} from "../../hooks/useCommonStore";
import {FormattedMessage, useIntl} from "react-intl";
import Layout from "../Layout/Layout";
import {useEffect, useState} from "react";
import api from "utils/api";
import LanguageModal from 'components/LanguageModal/LanguageModal';
import {useNavigate} from "react-router-dom";

const CompletionExamMain = () => {
    const {userInfo, access, startLoading, stopLoading} = useCommonStore();
    const lang = localStorage.getItem("lang");
    const navigate = useNavigate();
    const intl = useIntl();

    const [scheduledExamId, setScheduledExamId] = useState();
    const [isLanguageModal, setIsLanguageModal] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [rows, setRows] = useState([]);

    const statusList = [
        {name: intl.formatMessage({id: '@exam_main_status_1'}), value: 'READY'},
        {name: intl.formatMessage({id: '@exam_main_status_2'}), value: 'IN_PROGRESS'},
        {name: intl.formatMessage({id: '@exam_main_status_3'}), value: 'APPLIED'},
        {name: intl.formatMessage({id: '@exam_main_status_4'}), value: 'CLOSED'},
    ]
    const examTypeList = [
        {name: '쪽지시험', value: 'QUIZ'},
        {name: '종강시험', value: 'FINAL'},
        {name: intl.formatMessage({id: '@exam_main_pre_completion'}), value: 'PRE_COMPLETION'},
        {name: intl.formatMessage({id: '@exam_main_completion'}), value: 'COMPLETION'},
        {name: '기타시험', value: 'ETC'},
    ];

    const handleClickExam = (row) => {
        if (row.status === 'READY') {
            setScheduledExamId(row.scheduledExamId);
            setIsLanguageModal(true);
        } else if (row.status === 'IN_PROGRESS') {
            navigate(`/exam-room/${row.scheduledExamId}`);
        }
    }

    const handleSelectLanguage = async (selectedLang) => {
        if (window.confirm(intl.formatMessage({id: '@exam_main_lang_confirm'}))) {
            startLoading();
            const data = await api.post(`/v1/user-exam/scheduled/${scheduledExamId}`, {language: selectedLang});
            if (data) {
                navigate(`/exam-room/${scheduledExamId}`);
            }
        }
    }

    useEffect(() => {
        if (access.centerBatch) {
            handleClickSearch();
        }
    }, [access.centerBatch]);

    const handleClickSearch = async () => {
        startLoading();
        const {list, total} = await api.get(`/v1/user-exam/scheduled`, {
            params: {
                centerBatchId: access.centerBatch.centerBatchId,
                paginate: 'page',
                page: page,
                size: pageSize,
            }
        });
        setRows(list);
        setTotalCount(total);
        stopLoading();
    };

    return (
        <Layout>
            <div className='CompletionExamMain'>
                <div className='welcome'>
                    <FormattedMessage
                        id='@exam_main_greeting'
                        values={{user_name: userInfo.name}}
                    />
                    <div className='class'>{access.label}</div>
                </div>
                {
                    rows.map((row, i) => {
                        const findStatus = statusList.find(option => option.value === row.status);
                        return (
                            <div className='exam-item' key={i} onClick={() => handleClickExam(row)}>
                                <div className='exam-description'>
                                    {examTypeList.find(option => option.value === row.examType)?.name}
                                </div>
                                <div className='exam-content'>
                                    <div className='exam-title'>{row.title}</div>
                                    <div className={`exam-status ${findStatus?.value.toLowerCase()}`}>
                                        {findStatus?.name}
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <LanguageModal
                isModalOpen={isLanguageModal}
                closeModal={() => setIsLanguageModal(false)}
                handleSelect={handleSelectLanguage}
                scheduledExamId={scheduledExamId}
            />
        </Layout>
    );
}

export default CompletionExamMain;